import { Icon } from '@material-ui/core'
import React from 'react';

const Tv: React.FC = () => {
    return <Icon className="icon-small">tv</Icon>
}

export default Tv;